module.exports = __webpack_public_path__ + "static/media/announcement.b3b63928.png";